export const blockIconsTextformattingRequestQuoteNew = (
	<span className='material-symbols-outlined'>request_quote</span>
);
